/**
 * React-Admin component theme overrides
 *
 * Centralizes styling for React-Admin components to ensure consistency
 * and eliminate duplicate sx props throughout the codebase.
 */

import { TYPOGRAPHY, LAYOUT } from '../tokens';

export const reactAdminOverrides = {
  RaDatagrid: {
    styleOverrides: {
      root: {
        // Consistent row height across all datagrids
        '& .RaDatagrid-row': {
          height: `${LAYOUT.tableRowHeight}px`,
        },
      },
      headerCell: {
        // Bold headers for all datagrids
        fontWeight: TYPOGRAPHY.tableHeaderWeight,
      },
    },
  },
  RaTopToolbar: {
    styleOverrides: {
      root: {
        // Clean space-between layout without !important hacks
        justifyContent: 'space-between',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
      },
    },
  },
  RaMenuItemLink: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .RaMenuItemLink-icon': {
          minWidth: '40px',
        },
        padding: '10px',
        margin: '5px',
        fontSize: '0.9rem',
        borderRadius: '100px',
        '&.RaMenuItemLink-active': {
          backgroundColor: `${theme.palette.primary.main}26`, // 15% opacity
          color: theme.palette.primary.main,
          fontWeight: '600',
        },
      }),
    },
  },
};
